import React from 'react'
import { Price as LeshenPriceUI } from '@leshen/ui'

const SylexPrice = ({ brandyPackage, showFeaturedBullets, ...props }) => (
  <LeshenPriceUI
    {...brandyPackage?.price}
    priceIntro={brandyPackage?.price?.before}
    priceOld={brandyPackage?.price?.priceOld}
    bullets={brandyPackage?.node?.bullets}
    showFeaturedBullets={showFeaturedBullets}
    {...props}
  />
)

export default SylexPrice
